import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const MaintenanceRecords = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default MaintenanceRecords;
